var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-base',{attrs:{"caption":"ホーム","icon":"home","action":_vm.action,"route":"home"}})}
var staticRenderFns = []

export { render, staticRenderFns }